import React from "react";
import { withRouter } from "react-router-dom";
import { ActionType, ArrangemangDisplayType } from "../../../utils/Enums";
import injectSheet from "react-jss";
import styles from "./NavMenusStyles"; // Import styles
import GetUser from "../../../utils/UserFunctions/GetUser";
import Tooltip from "../../Tooltip/TooltipPopup";

function Addmenu(props) {
  const handleNew = (event) => {
    if (props.toggleSubmenu) props.toggleSubmenu();
    if (props.toggleMobileMenu) props.toggleMobileMenu();

    var typs = event.target.value.split(",");
    var arrangemang = {
      id: 0,
      avdelning: { id: null, kod: null, namn: null },
      verksamhetsform: {
        id: Number(typs[1]),
        kod: typs[1],
        namn: event.target.innerText.replace(" +", ""),
      },
      arrangemangstyp: {
        id: Number(typs[0]),
        kod: typs[0],
        namn: "arrangemangstyp",
      },
      actions: ActionType.Skapa,
      status: -1,
      view: ArrangemangDisplayType.ArrangemangWizard,
      externtSkapadAvID: GetUser().id,
    };

    props.history.push({
      pathname: "/skapa/0",
      state: {
        data: arrangemang,
        view: ArrangemangDisplayType.ArrangemangWizard,
      },
    });
  };

  const { classes } = props;
  return (
    <div className={classes.navmenu}>
      {props.hideHeader ? null : <h4>Skapa arrangemang</h4>}
      <ul>
        <li>
          <button
            value="1,1"
            onClick={handleNew}
            data-toggle="popover"
            data-tooltip-content="Studiecirkel (minst 3 deltagare, 3 tillfällen och minst 9 studietimmar)"
            data-tooltip-id="bottom"
            data-tooltip-variant="light"
          >
            Studiecirkel
          </button>
        </li>
        <li>
          <button
            value="1,2"
            onClick={handleNew}
            data-tooltip-content="Kulturprogram (1 tillfälle, framförs inför publik)"
            data-tooltip-id="bottom"
            data-tooltip-variant="light"
          >
            Kulturprogram
          </button>
        </li>
        <li>
          <button
            value="1,3"
            onClick={handleNew}
            data-tooltip-content="Annan folkbildningsverksamhet (minst 3 deltagare, minst en sammankomst)"
            data-tooltip-id="bottom"
            data-tooltip-variant="light"
          >
            Annan folkbildningsverksamhet
          </button>
        </li>
        {/* <li>
          <button
            value="2,1"
            onClick={handleNew}
            data-tooltip-content="Svenska från dag 1, studiecirkel (minst 3 deltagare, 3 tillfällen och minst 9 studietimmar)"
            data-tooltip-id="bottom"
            data-tooltip-variant="light"
          >
            Svenska från dag 1, studiecirkel
          </button>
        </li>
        <li>
          <button
            value="2,3"
            onClick={handleNew}
            data-tooltip-content="Svenska från dag 1, annan folkbildningsverksamhet (minst 3 deltagare, minst en sammankomst)"
            data-tooltip-id="bottom"
            data-tooltip-variant="light"
          >
            Svenska från dag 1, annan folkbildningsverksamhet
          </button>
        </li> */}
      </ul>
      <Tooltip />
    </div>
  );
}
export default injectSheet(styles)(withRouter(Addmenu));
